import { styled } from '@mui/material/styles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';

const defaultColumn = { width: 0 };

export const StyledDatagrid = styled(DatagridWithStickyActions)({
  '& .column-createdAt': defaultColumn,
  '& .column-updatedAt': defaultColumn,
  '& .MuiTableCell-root': {
    verticalAlign: 'middle',
  },
});
